import type { FetchArgs } from '@reduxjs/toolkit/query/react';
import type {
  CreateExpenseInvoiceDto,
  CreateSimplifiedExpenseInvoiceDto,
  UpdateExpenseInvoiceDto,
  UpdateSimplifiedExpenseInvoiceDto,
} from '../Types/expenseInvoice.types';

export const buildCreateExpenseInvoiceRequest = (
  payload: CreateExpenseInvoiceDto
): FetchArgs => ({
  url: '/expense-invoices',
  method: 'POST',
  body: payload,
});

export const buildUpdateExpenseInvoiceRequest = ({
  id,
  data,
}: {
  id: number;
  data: UpdateExpenseInvoiceDto;
}): FetchArgs => ({
  url: `/expense-invoices/${id}`,
  method: 'PUT',
  body: data,
});

export const buildCreateSimplifiedExpenseInvoiceRequest = (
  payload: CreateSimplifiedExpenseInvoiceDto
): FetchArgs => ({
  url: '/expense-invoices/simplified',
  method: 'POST',
  body: payload,
});

export const buildUpdateSimplifiedExpenseInvoiceRequest = ({
  id,
  data,
}: {
  id: number;
  data: UpdateSimplifiedExpenseInvoiceDto;
}): FetchArgs => ({
  url: `/expense-invoices/${id}/simplified`,
  method: 'PUT',
  body: data,
});
